// extracted by mini-css-extract-plugin
export var currencyInput = "_kx-1";
export var currencySymbol = "_kx-0";